import ApiService from "../../api/api";
const HISTORY_STATUS = window.laravel.historyStatus;

const defaultShownPages = {
    [HISTORY_STATUS.famous]: [],
    [HISTORY_STATUS.military]: [],
    [HISTORY_STATUS.interesting]: [],
    [HISTORY_STATUS.artists]: [],
    [HISTORY_STATUS.politicians]: [],
    [HISTORY_STATUS.scientists]: [],
    [HISTORY_STATUS.athletes]: [],
    clone() {
        return JSON.parse(JSON.stringify(this));
    }
};

export default {
    namespaced: true,
    state() {
        return {
            page: null,
            pages: [],
            historyStatusId: null,
            shownPages: defaultShownPages.clone(),
            memorial: null,
        }
    },
    mutations: {
        setShownPages(state, value = []) {
            value.forEach(function (status) {
                state.shownPages[status.id] = [];
            });
        },
        resetShowPages(state, pages) {
            if (pages.length > 0) {
                return;
            }
            state.shownPages = defaultShownPages.clone();
        },
        setPage(state, value) {
            state.page = value;
        },
        setPages(state, value) {
            state.pages = value;
        },
        setMemorial(state, value) {
            state.memorial = value;
        },
        setHistoryStatusId(state, value) {
            state.historyStatusId = value;
        },
    },
    getters: {
        page(state) {
            return state.page;
        },
        pages(state) {
            return state.pages;
        },
        memorial(state) {
            return state.memorial;
        },
        historyStatusId(state) {
            return state.historyStatusId;
        },
    },
    actions: {
        getPages({commit, state}) {
            let pageIds = [];

            Object.values(state.shownPages).forEach(ids => {
                pageIds = pageIds.concat(ids);
            });

            return new Promise((resolve, reject) => {
                ApiService.post('/page/per-historical-status', {
                    shownPages: pageIds, historyStatusId: state.historyStatusId,
                }).then(response => {
                    let pages = response.data.pages;
                    let shownPages = response.data.shown_pages;
                    let pagesLeft = response.data.pages_left;

                    commit('setPage', pages[Math.floor(Math.random() * pages.length)]);
                    commit('setPages', pages);
                    commit('resetShowPages', shownPages);

                    pages.forEach(page => {
                        let shownPages = state.shownPages[page.historical_status_id];

                        if (pagesLeft[page.historical_status_id] > 0) {
                            shownPages.push(page.id);
                        } else if (pagesLeft[page.historical_status_id] === 0 && shownPages.length === 0) {
                            state.shownPages[page.historical_status_id] = [];
                        } else {
                            state.shownPages[page.historical_status_id] = [page.id];
                        }
                    });

                    resolve(response);
                }).catch(error => {
                    reject(error);
                    console.log(error)
                });
            });
        },
        getMemorial({commit, state}) {
            let previousId = state.memorial ? state.memorial.id : null;

            return new Promise((resolve, reject) => {
                ApiService.get('/memorial/random', {previousId: previousId}).then((response) => {
                    commit('setMemorial', response.data);
                }).catch(error => {
                    reject(error);
                    console.log(error)
                });
            });
        },
    },
}
